var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-7"},[_c('my-jobs-card')],1),_c('div',{staticClass:"col-md-5"},[_c('faf-all-active-jobs-table')],1)]),_c('production-table-card')],1)}
var staticRenderFns = []

export { render, staticRenderFns }